module.exports = __webpack_public_path__ + "static/media/Marketplacebackgroundtooltipimage.e6a9b471.png";